"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Grid;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createProps = _interopRequireDefault(require("../../utils/createProps"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  fluid: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  tagName: _propTypes["default"].string,
  children: _propTypes["default"].node
};
function Grid(props) {
  var containerClass = props.fluid ? 'container-fluid' : 'container';
  var classNames = [props.className, containerClass];
  return /*#__PURE__*/_react["default"].createElement(props.tagName || 'div', (0, _createProps["default"])(propTypes, props, classNames));
}
Grid.propTypes = propTypes;